/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const SESSIONS = {
	DEFAULT_STORAGE_ADAPTER_NAME: "adapptio",
	EXPIRATION: {
		// 1 year
		COOKIE: 365 * 24 * 60 * 60 * 1000,
		// 1 month
		STORAGE: 30 * 24 * 60 * 60 * 1000,
		// 1 month
		LAST_LOGIN: 30 * 24 * 60 * 60 * 1000
	},
	STORAGE: {
		FILENAME: "../var/sessions.json",
		// 1 month
		TTL_IN_MILLISECONDS: 1000 * 60 * 60 * 30,
		TTL_INTERVAL_IN_MILLISECONDS: 10000
	}
};
